import { render, staticRenderFns } from "./AlphabetPreview.vue?vue&type=template&id=6fb28a7c&lang=pug&"
import script from "./AlphabetPreview.vue?vue&type=script&lang=js&"
export * from "./AlphabetPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports